exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./palette.png"));

// Module
exports.push([module.id, ".palette-card-colorList-2r_7A{display:flex;justify-content:space-between;width:270px}.palette-card-color-1IBdh{cursor:pointer;width:30px;height:30px;border:1.5px solid transparent;border-radius:50%;padding:1.5px;background:content-box}.palette-card-color-1IBdh.palette-card-selected-1Yqta,.palette-card-color-1IBdh:hover{border:1.5px solid #00a3f5}.palette-card-palette-xeR2e{background-image:url(" + ___CSS_LOADER_URL___0___ + ");background-size:100%}.palette-card-sliderWrapper-2u7KD *{box-sizing:border-box!important}.palette-card-sliderWrapper-2u7KD input{border-radius:6px!important;background:transparent!important}", ""]);

// Exports
exports.locals = {
	"colorList": "palette-card-colorList-2r_7A",
	"color": "palette-card-color-1IBdh",
	"selected": "palette-card-selected-1Yqta",
	"palette": "palette-card-palette-xeR2e",
	"sliderWrapper": "palette-card-sliderWrapper-2u7KD"
};